import { Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { RootState } from "../../redux/store";
import routes from "../../routes/routes";
import BookLocationHeader from "../bookLocation/common/util/BookLocationHeader";
import Header from "../layout/components/Header";
import TenantLogo from "../layout/components/TenantLogo";
import LanguageSwitcher from "./components/LanguageSwitcher";

const HintsPage = () => {
  const { i18n } = useTranslation();
  const tenantConfig = useSelector(
    (state: RootState) => state.tenantConfig.config
  );
  const hintPages: Record<string, any> =
    useSelector((state: RootState) => state.hints.pages) || {};

  const excludes = ["ReceiverFaqsPage"];
  const filterHintPages = Object.keys(hintPages || {}).reduce(
    (acc: Record<string, any>, curr: string) => {
      if (!excludes.includes(curr)) {
        acc[curr] = hintPages[curr];
      }
      return acc;
    },
    {}
  );

  // Render links to hint pages
  const renderHintLinks = (pages: { [key: string]: any }) => {
    if (tenantConfig.content?.[i18n.language]?.hints) {
      return tenantConfig.content[i18n.language].hints?.map(
        ({ menu_item, url }) => {
          return (
            <Link
              key={`hints-${url}`}
              className="!no-underline !font-medium !text-xl"
              component={RouterLink}
              to={routes.makeHintsPath(url)}
            >
              {menu_item}
            </Link>
          );
        }
      );
    }

    return Object.keys(pages).map((key) =>
      pages[key].type === "link" ? (
        <a
          key={key}
          className="!no-underline !font-medium !text-xl"
          href={(pages[key].content as any)?.[i18n.language]?.content}
          target="_blank"
          rel="noreferrer"
        >
          {(pages[key].content as any)?.[i18n.language]?.title}
        </a>
      ) : (
        <Link
          key={key}
          className="!no-underline !font-medium !text-xl"
          component={RouterLink}
          to={routes.makeHintsPath(key)}
        >
          {(pages[key].content as any)?.[i18n.language]?.title}
        </Link>
      )
    );
  };

  return (
    <div className="min-h-full px-5">
      <Header>
        <TenantLogo />
      </Header>
      <BookLocationHeader text="Infos" />
      <div className="flex flex-col items-center gap-4 mt-12">
        {filterHintPages && renderHintLinks(filterHintPages)}
      </div>
      {tenantConfig?.languages.length! > 1 && <LanguageSwitcher />}
    </div>
  );
};

export default HintsPage;
